import { SelectComponent as h } from "../SelectComponent/SelectComponent.js";
import '../assets/AdvanceSearch.css';const g = "op_sqlLineHolder_UNSjd", E = "op_sqlConditionHolder_vVN1F", N = "op_sqlComponentHolder_NlA1m", R = "op_sqlInsertButton_6SiUw", H = "op_sqlDeleteButton_szPcy", S = "op_sqlConditionOperator_lZmlN", O = "op_sqlComponentControlHolder_DC5QF", b = "op_advanceSearchHolder_86xtq", l = {
  sqlLineHolder: g,
  sqlConditionHolder: E,
  sqlComponentHolder: N,
  sqlInsertButton: R,
  sqlDeleteButton: H,
  sqlConditionOperator: S,
  sqlComponentControlHolder: O,
  advanceSearchHolder: b
}, { useState: C, useEffect: w, isValidElement: y, createElement: B, cloneElement: D } = wp.element;
function x(o) {
  let {
    change: e,
    runSearch: n,
    fieldOptions: t,
    operatorConditions: a,
    inputConditions: u,
    searchSettings: c,
    defaultCondition: i
  } = o;
  return /* @__PURE__ */ React.createElement("div", { className: l.advanceSearchHolder }, /* @__PURE__ */ React.createElement(
    f,
    {
      searchSettings: c,
      change: e,
      fieldOptions: t,
      operatorConditions: a,
      inputConditions: u,
      defaultCondition: i
    }
  ), /* @__PURE__ */ React.createElement("button", { className: "resf-button", onClick: n }, "🔎︎ Search"));
}
function f(o) {
  let {
    path: e = "_condition_group",
    searchSettings: n,
    change: t,
    fieldOptions: a,
    operatorConditions: u,
    inputConditions: c,
    defaultCondition: i
  } = o, r = 0, _ = n._conditions.map((s, d) => {
    if (r = d, s == null)
      return;
    let m = e + "._conditions." + d;
    return s._condition_group !== void 0 ? /* @__PURE__ */ React.createElement(
      f,
      {
        ...o,
        path: m + "._condition_group",
        searchSettings: s._condition_group
      }
    ) : /* @__PURE__ */ React.createElement(
      I,
      {
        ...o,
        path: m + "._condition",
        searchSettings: s._condition,
        key: r
      }
    );
  });
  return /* @__PURE__ */ React.createElement("div", { className: l.sqlLineHolder }, /* @__PURE__ */ React.createElement("div", { className: l.sqlComponentHolder }, /* @__PURE__ */ React.createElement(
    L,
    {
      conditions: _,
      value: n._condition_group_operator,
      onChange: t,
      name: e + "._condition_group_operator"
    }
  )), /* @__PURE__ */ React.createElement("div", { className: l.sqlComponentControlHolder }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "resf-button " + l.sqlInsertButton + " dashicons-before dashicons-insert",
      onClick: t,
      name: e + "._conditions." + (r + 1) + "._condition",
      value: JSON.stringify(i),
      "data-json": !0
    },
    "New condition"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "resf-button " + l.sqlInsertButton,
      onClick: t,
      name: e + "._conditions." + (r + 1) + "._condition_group",
      value: JSON.stringify({ _conditions: [{ _condition: i }], _condition_group_operator: "AND" }),
      "data-json": !0
    },
    "Add Group"
  ), e !== "_condition_group" ? /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "resf-button",
      onClick: t,
      name: e.substring(0, e.lastIndexOf(".")),
      "data-action": "delete"
    },
    "Delete Group"
  ) : ""));
}
function I(o) {
  let e = {
    full: [
      { name: "Starts with", value: "starts_with" },
      { name: "Contains", value: "contains" },
      { name: "Ends with", value: "ends_with" },
      { name: "Equal to", value: "=" },
      { name: "Greater than", value: ">" },
      { name: "Less than", value: "<" },
      { name: "Greater or equal to", value: "<=" },
      { name: "Not equal to", value: "<>" },
      { name: "Less than or equal to", value: "<=" }
    ],
    dateNumber: [
      { name: "Equal to", value: "=" },
      { name: "Greater than", value: ">" },
      { name: "Less than", value: "<" },
      { name: "Greater or equal to", value: "<=" },
      { name: "Not equal to", value: "<>" },
      { name: "Less than or equal to", value: "<=" }
    ],
    text: [
      { name: "Starts with", value: "starts_with" },
      { name: "Contains", value: "contains" },
      { name: "Ends with", value: "ends_with" },
      { name: "Equal to", value: "=" }
    ]
  }, {
    path: n,
    searchSettings: t,
    change: a,
    fieldOptions: u,
    operatorConditions: c = (v, k) => v.full,
    inputConditions: i = (v) => ({ inputType: "input", type: "text" }),
    key: r
  } = o, [_, s] = C(c(e, t._field)), [d, m] = C(i(t._field)), { inputType: p, type: q } = d;
  return w(() => {
    s(c(e, t._field)), m(i(t._field));
  }, [o]), /* @__PURE__ */ React.createElement("div", { className: l.sqlConditionHolder + " resf-puff ", key: r }, /* @__PURE__ */ React.createElement(
    h,
    {
      options: u,
      value: t._field,
      onChange: a,
      name: n + "._field"
    }
  ), /* @__PURE__ */ React.createElement(
    h,
    {
      options: _,
      value: t._operator_and_value._operator,
      onChange: a,
      name: n + "._operator_and_value._operator"
    }
  ), y(p) ? D(p, { value: t._value, onChange: a, name: n + "._operator_and_value._value" }) : B(p, { type: q, value: t._value, onChange: a, name: n + "._operator_and_value._value" }), n !== "_condition_group._conditions.0._condition" ? /* @__PURE__ */ React.createElement(
    "button",
    {
      name: n.substring(0, n.lastIndexOf(".")),
      className: "resf-button resf-delete-button " + l.sqlDeleteButton,
      onClick: a,
      "data-action": "delete"
    },
    "✗"
  ) : "");
}
function L(o) {
  return o.conditions.filter((e) => e).reduce((e, n, t, a) => (e.push(n), t < a.length - 1 && e.push(/* @__PURE__ */ React.createElement(
    "select",
    {
      className: l.sqlConditionOperator,
      value: o.value,
      onChange: o.onChange,
      name: o.name
    },
    /* @__PURE__ */ React.createElement("option", { value: "OR" }, "OR"),
    /* @__PURE__ */ React.createElement("option", { value: "AND" }, "AND")
  )), e), []);
}
export {
  x as AdvanceSearch,
  I as Condition,
  f as ConditionGroup,
  L as ConditionsWithOperators
};
